import API_CONFIG from './apiConfig.js';

const CLIENT_ID = API_CONFIG.CLIENT_ID;
const API_CLIENT_ID = API_CONFIG.API_CLIENT_ID || API_CONFIG.CLIENT_ID;
const TENANT_ID = API_CONFIG.TENANT_ID;
const deploymentAudience = API_CONFIG.DEPLOYMENT_AUDIENCE;
const API_SCOPE = API_CONFIG.API_SCOPE || `api://${API_CLIENT_ID}/.default`;

const authorityHost = deploymentAudience === 'internal'
    ? 'login.microsoftonline.com'
    : 'nsiexternalsaas.ciamlogin.com';
const msalAuthority = `https://${authorityHost}/${TENANT_ID}`;
const msalKnownAuthorities = [authorityHost];

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: msalAuthority,
        knownAuthorities: msalKnownAuthorities,
        redirectUri: API_CONFIG.FRONTEND_URL,
        postLogoutRedirectUri: API_CONFIG.FRONTEND_URL,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0: // Error
                        console.error(message);
                        return;
                    case 1: // Warning
                        console.warn(message);
                        return;
                    case 2: // Info (This puts out a lot of info, comment out if getting spam)
                        //console.info(message);
                        return;
                    case 3: // Verbose
                        //console.debug(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ["openid", "profile", "email"],
};

// For API calls, request a token for the backend API audience.
export const apiRequest = {
    scopes: [API_SCOPE],
};